import { useQuery } from '@tanstack/react-query';
import {
  dashboardSummaryApi,
  dashboardRevenueByCategoryApi,
  dashboardTopProductsApi,
  dashboardStockWeightApi,
} from '../../api/api';

export const useDashboardSummary = (params) =>
  useQuery({
    queryKey: ['dashboard-summary', params],
    queryFn: () => dashboardSummaryApi(params),
  });

export const useDashboardRevenueByCategory = (params) =>
  useQuery({
    queryKey: ['dashboard-revenue-category', params],
    queryFn: () => dashboardRevenueByCategoryApi(params),
  });

export const useDashboardTopProducts = (params) =>
  useQuery({
    queryKey: ['dashboard-top-products', params],
    queryFn: () => dashboardTopProductsApi(params),
  });

export const useDashboardStockWeight = () =>
  useQuery({
    queryKey: ['dashboard-stock-weight'],
    queryFn: dashboardStockWeightApi,
  });
